import { addMaterialSlice } from './reducer'
import { saveMaterial } from './api'

const {
  setMaterialTitle,
  setSequenceNumber,
  setText,
  setType,
  setImage,
  setSnyposis,
  setVideoChat,
  setVideoUrl,
  resetMaterialState,
  setError
} = addMaterialSlice.actions

export {
  setMaterialTitle,
  setSequenceNumber,
  setText,
  setType,
  setImage,
  setSnyposis,
  setVideoChat,
  setVideoUrl,
  resetMaterialState,
  saveMaterial,
  setError
}
